export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "API Url": "API-URL",
        "Bazowy adres API Ipresso.": "Basisadresse der Ipresso-API.",
        "CUSTOMER_KEY": "CUSTOMER_KEY",
        "Dane dostępowe integracji marketing automation.": "Zugangsdaten für die Marketing-Automation-Integration.",
        "Dane są nie prawidłowe.": "Die Daten sind ungültig.",
        "Dane są prawidłowe.": "Die Daten sind gültig.",
        "Hasło": "Passwort",
        "Hasło konta integracyjnego.": "Passwort des Integrationskontos.",
        "Ipresso": "Ipresso",
        "Klucz klienta nadany przez Ipresso.": "Von Ipresso vergebener Kundenschlüssel.",
        "Login": "Login",
        "Login konta integracyjnego.": "Login des Integrationskontos.",
        "Paleta kolorów": "Farbpalette",
        "Pokaż hasło": "Passwort anzeigen",
        "Pokaż klucz klienta": "Kundenschlüssel anzeigen",
        "Połączenie Ipresso": "Ipresso-Verbindung",
        "Przetestuj poprawność danych": "Gültigkeit der Daten testen",
        "Synchronizacja kontaktów": "Kontaktsynchronisierung",
        "Synchronizacja ustawień": "Synchronisierung der Einstellungen",
        "Synchronizacja zgód kontaktów": "Synchronisierung der Kontakteinwilligungen",
        "System": "System",
        "Ukryj hasło": "Passwort ausblenden",
        "Ukryj klucz klienta": "Kundenschlüssel ausblenden",
        "Ustawienia": "Einstellungen",
        "Ustawienia zostały zapisane.": "Die Einstellungen wurden gespeichert.",
        "Zadanie synchronizacji kontaktów Ipresso zostało rozpoczęte.": "Die Aufgabe zur Ipresso-Kontaktsynchronisierung wurde gestartet.",
        "Zadanie synchronizacji ustawień Ipresso zostało rozpoczęte.": "Die Aufgabe zur Ipresso-Synchronisierung der Einstellungen wurde gestartet.",
        "Zadanie synchronizacji zgód kontaktów Ipresso zostało rozpoczęte.": "Die Aufgabe zur Synchronisierung der Ipresso-Kontakteinwilligungen wurde gestartet.",
        "Zapisz": "Speichern"
    }
};
